
import { IResult } from "@/types/map";
import { Vue, Component, Prop } from "vue-property-decorator";
import GeometrySearchPGIS from "../../GeometrySearch/pgis/GeometrySearchPGIS";
declare let BMap: any;
@Component
export default class searchPop extends Vue {
  @Prop({ type: Object }) map!: any;

  private ruleForm: { name: string; region: string; type: string } = {
    name: "",
    region: "",
    type: "POI",
  };
  private areaBtnList: any[] = [
    {
      icon: "circular",
    },
    {
      icon: "square",
    },
    {
      icon: "polygon",
    },
  ];
  private areaActive: number = 0;

  private ClickActive(index: number) {
    this.areaActive = index;
    this.drawGeometrySearch(index);
  }

  private drawGeometrySearch(index: number) {
    let geometrySearch = GeometrySearchPGIS.getInstance(
      this.map,
      this.map.fmap
    );
    geometrySearch.clearGeometrySearch();
    let result;
    switch (index) {
      case 0:
        geometrySearch.startGeometrySearch({
          drawType: "circle",
          // key: this.ruleForm.name,
          types: [this.ruleForm.name],
        });
        break;
      case 1:
        geometrySearch.startGeometrySearch({
          drawType: "rectangle",
          // key: this.ruleForm.name,
          types: [this.ruleForm.name],
        });
        break;
      case 2:
        geometrySearch.startGeometrySearch({
          drawType: "polygon",
          // key: this.ruleForm.name,
          types: [this.ruleForm.name],
        });
        break;
    }
  }

  private closeBtn() {
    (this.$el as any).style.display = "none";
  }

  private startSearch() {
    this.searchOverlay();
  }

  private clearSearch() {
    let geometrySearch = GeometrySearchPGIS.getInstance(
      this.map,
      this.map.fmap
    );
    geometrySearch.clearGeometrySearch();
  }

  private searchOverlay() {
    const geo = GeometrySearchPGIS.getInstance(this.map, this.map.fmap);
    geo.startSearchByKey({ key: this.ruleForm.name });
  }
}
